import { createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e1379c9e")

_pushScopeId("data-v-e1379c9e")
const _hoisted_1 = {
  class: "block-title sticky-title",
  style: {"display":"flex","justify-content":"space-between"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", null, "Transactions", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Load more")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Close")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Save")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_f7_link = _resolveComponent("f7-link")
  const _component_f7_list_item = _resolveComponent("f7-list-item")
  const _component_f7_list = _resolveComponent("f7-list")
  const _component_f7_popover = _resolveComponent("f7-popover")
  const _component_f7_button = _resolveComponent("f7-button")
  const _component_f7_preloader = _resolveComponent("f7-preloader")
  const _component_f7_nav_right = _resolveComponent("f7-nav-right")
  const _component_f7_navbar = _resolveComponent("f7-navbar")
  const _component_f7_list_input = _resolveComponent("f7-list-input")
  const _component_f7_block = _resolveComponent("f7-block")
  const _component_f7_page = _resolveComponent("f7-page")
  const _component_f7_popup = _resolveComponent("f7-popup")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createVNode(_component_f7_link, {
        onclick: () => _ctx.newTransaction(),
        "icon-aurora": "f7:plus",
        tooltip: "Add a transaction"
      }, null, 8, ["onclick"]), [
        [_vShow, _ctx.isAdmin]
      ])
    ]),
    _createVNode(_component_f7_list, {
      "media-list": "",
      "no-hairlines": "",
      class: "no-padding no-margin"
    }, {
      default: _withId(() => [
        (_ctx.rewardsStore.isLoading)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, _renderList(3, (n) => {
              return _createVNode(_component_f7_list_item, {
                key: n,
                class: "skeleton-text skeleton-effect-wave",
                title: "Loading",
                subtitile: "Loading transaction",
                text: "this is a transaction.....",
                after: "....."
              })
            }), 64))
          : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rewardsStore.transactions, (transaction) => {
                return (_openBlock(), _createBlock(_component_f7_list_item, {
                  key: transaction.id,
                  text: transaction.description,
                  after: _ctx.formatDate(transaction.createdAt),
                  subtitle: _ctx.formatPrice(transaction.price),
                  title: `${_ctx.formatPoints(transaction.points)} points ${_ctx.getText(transaction)}`
                }, {
                  after: _withId(() => [
                    _withDirectives(_createVNode(_component_f7_link, {
                      "popover-open": `.popover-menu-${transaction.id}`,
                      style: {"margin-left":"10px"},
                      "icon-aurora": "f7:ellipsis_vertical"
                    }, null, 8, ["popover-open"]), [
                      [_vShow, _ctx.isAdmin]
                    ]),
                    _createVNode(_component_f7_popover, {
                      class: `popover-menu-${transaction.id}`
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_f7_list, null, {
                          default: _withId(() => [
                            _createVNode(_component_f7_list_item, {
                              link: "#",
                              "popover-close": "",
                              title: "Edit",
                              onclick: () => _ctx.editTransaction(transaction)
                            }, null, 8, ["onclick"]),
                            _createVNode(_component_f7_list_item, {
                              link: "#",
                              "popover-close": "",
                              title: "Delete",
                              onclick: () => _ctx.deleteTransaction(transaction.id!)
                            }, null, 8, ["onclick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["class"])
                  ]),
                  _: 2
                }, 1032, ["text", "after", "subtitle", "title"]))
              }), 128)),
              (!_ctx.loadedAllTransactions && _ctx.rewardsStore.transactions.length > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_3, [
                    (!_ctx.isLoadingMoreTransactions)
                      ? (_openBlock(), _createBlock(_component_f7_button, {
                          key: 0,
                          onclick: _ctx.loadMoreTransactions
                        }, {
                          default: _withId(() => [
                            _hoisted_4
                          ]),
                          _: 1
                        }, 8, ["onclick"]))
                      : (_openBlock(), _createBlock(_component_f7_preloader, { key: 1 }))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
      ]),
      _: 1
    }),
    _createVNode(_component_f7_popup, { id: "add-transaction-popup" }, {
      default: _withId(() => [
        _createVNode(_component_f7_page, null, {
          default: _withId(() => [
            _createVNode(_component_f7_navbar, {
              title: `${_ctx.currentTransaction.id !== '' ? 'Add' : 'Edit'} Transaction`
            }, {
              default: _withId(() => [
                _createVNode(_component_f7_nav_right, null, {
                  default: _withId(() => [
                    _createVNode(_component_f7_link, { "popup-close": "" }, {
                      default: _withId(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode(_component_f7_list, {
              form: "",
              "no-hairlines": "",
              style: {"margin":"0"}
            }, {
              default: _withId(() => [
                _createVNode(_component_f7_list_input, {
                  outline: "",
                  label: "Price",
                  type: "number",
                  value: _ctx.currentTransaction.price,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentTransaction.price = $event))
                }, null, 8, ["value"]),
                _createVNode(_component_f7_list_input, {
                  outline: "",
                  label: "Points",
                  type: "number",
                  value: _ctx.currentTransaction.points,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.currentTransaction.points = $event))
                }, null, 8, ["value"]),
                _createVNode(_component_f7_list_input, {
                  outline: "",
                  label: "Description",
                  type: "textarea",
                  value: _ctx.currentTransaction.description,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.currentTransaction.description = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_f7_block, {
              strong: "",
              "no-hairlines": "",
              style: {"margin":"0"}
            }, {
              default: _withId(() => [
                _createVNode(_component_f7_button, {
                  onClick: _ctx.saveTransaction,
                  fill: "",
                  preloader: "",
                  loading: _ctx.isSavingTransaction
                }, {
                  default: _withId(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["onClick", "loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
})